export function proxyStatusColor(status: string): "success" | "error" | "default" {
  let proxyStatusColorOutcome: "success" | "error" | "default";
  if (status === "active") {
    proxyStatusColorOutcome = "success";
  } else {
    if (status === "inactive") {
      proxyStatusColorOutcome = "error";
    } else {
      proxyStatusColorOutcome = "default";
    }
  }
  return proxyStatusColorOutcome;
}
